module.exports = __webpack_public_path__ + "media/images/logoBTJ-f604eb2df71820f2c62bc939d61c9343.svg";